import { Field } from 'formik';
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from 'globalcomponents/UI/Button/Clutch';
import Label from 'globalcomponents/UI/FormLabel/Clutch';
import Link from 'globalcomponents/UI/Link';
import Message from 'globalcomponents/UI/Message/Clutch';
import { pageUrls } from 'globalconfig/constants/keys';
import { getMediaPath, mediaUrls } from 'globalconfig/constants/mediaUrls';
import { SvgIcon } from '@material-ui/core';

const layout = window.$environment?.CURRENT_LAYOUT;
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const CheckBox = lazy(() => import(`globalcomponents/UI/Checkbox/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;

const RenderComponent = ({ values, handleEdit, errors, isNotValid, validateForm, customProps, submitAction }) => {
  const { i18n } = useTranslation();

  const handleTogglePasswordVisibility = () => {
    const passwordField = document.getElementById('loginPassword');
    if (passwordField) {
      passwordField.type = passwordField.type === 'password' ? 'text' : 'password';
    }
  };

  const handleLoginClick = () => {
    validateForm().then((data) => {
      submitAction(data);
    });
  };

  return (
    <>
      <customProps.Styled.LoginHeader>
        <img alt="logo" src={getMediaPath(mediaUrls.clutchLogo, true)} className="ClutchLogo" />
      </customProps.Styled.LoginHeader>

      <customProps.Styled.LoginContent newUI>
        {customProps?.hasLoginApiStatus?.errorMessage && (
          <customProps.Styled.LoginError>
            <Message type="error" message={customProps.hasLoginApiStatus.errorMessage} />
          </customProps.Styled.LoginError>
        )}

        {/* Username Field */}
        <customProps.Styled.userNameWrapper>
          <FormStyle.FieldsWrapper width="100%">
            <Label variant="body1" mode="light" className="labelSize">
              {i18n.t('Username')}
            </Label>
            <FormStyle.TextWrapper mode="light">
              <Field
                name="username"
                handleOnChange={(event) => handleEdit(event, { field: 'username', type: 'username' })}
                as={Input}
                mode="light"
                placeholder={i18n.t('Username or Email')}
                value={values.username}
                type="text"
                id="usernameLogin"
                onLoadFocus
              />
              {errors.username && !isNotValid && <Message type="error" message={errors.username} />}
            </FormStyle.TextWrapper>
          </FormStyle.FieldsWrapper>
        </customProps.Styled.userNameWrapper>

        {/* Password Field */}
        <customProps.Styled.passwordWrapper>
          <FormStyle.FieldsWrapper width="100%">
            <span className="password-labels">
              <Label variant="body1" mode="light">
                {i18n.t('common.password')}
              </Label>
              <Link className="forgot-password" href={pageUrls.recovery} tabIndex={-1}>
                {i18n.t('Forgot password?')}
              </Link>
            </span>

            <FormStyle.TextWrapper className="passwordField">
              <Field
                name="password"
                handleOnChange={(event) => handleEdit(event, { field: 'password', type: 'password' })}
                as={Input}
                mode="light"
                placeholder={i18n.t('common.password')}
                value={values.password}
                type="password"
                id="loginPassword"
              />
              <SvgIcon value={mediaUrls.viewMoreIcon} alt="toggle password visibility" onClick={handleTogglePasswordVisibility} />
              {errors.password && !isNotValid && <Message type="error" message={errors.password} />}
            </FormStyle.TextWrapper>
          </FormStyle.FieldsWrapper>
        </customProps.Styled.passwordWrapper>

        {/* Remember Me */}
        <customProps.Styled.PasswordHandler newUI>
          <CheckBox
            type="NormalGrey"
            checked={values.rememberMe}
            className="remember remember-light-theme"
            label={i18n.t('Remember me')}
            onClick={(event) => handleEdit(event, { field: 'rememberMe', type: 'checkbox' })}
          />
        </customProps.Styled.PasswordHandler>

        {/* Submit Button */}
        <customProps.Styled.LoginButtonWrapper width="50%" newUI={window.$environment?.clutchNewUI}>
          <FormStyle.ButtonsWrapper>
            <Button
              type="submit"
              label={customProps?.hasLoginApiStatus?.isLoading ? <CircularProgress color="inherit" /> : i18n.t('Login')}
              onClick={handleLoginClick}
              id="loginButton"
            />
          </FormStyle.ButtonsWrapper>
        </customProps.Styled.LoginButtonWrapper>
      </customProps.Styled.LoginContent>

      {/* Footer */}
      <span className="patentText">Copyright &copy; 2006 - 2021 Webfleet Solutions B.V. All rights reserved.</span>
    </>
  );
};

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  customProps: PropTypes.object,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
};

export default RenderComponent;
